import WcsEyemed from '../wcs/eyemed'
import { EarlyAccessModule } from './EarlyAccessModule'
import { PrescriptionModule } from './PrescriptionModule'
import { VirtualMirrorModule } from './VirtualMirrorModule'

export class RoxLensPanel {
  static getEarlyAccessModule = () => {
    return new EarlyAccessModule()
  }

  static getPrescriptionModule = () => {
    return new PrescriptionModule()
  }

  static getVirtualMirrorModule = () => {
    return VirtualMirrorModule.getConfig()
  }

  static mapInsuranceDiscounts = (
    selectedPackages: any,
    frameroxFrameCatEntryId: number,
    updateBenefits: (_benefits: unknown) => void
  ) => {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async function (resolve) {
      const _insurancePackages = JSON.parse(JSON.stringify(selectedPackages))
      for (let i = 0; i < _insurancePackages.length; i++) {
        const postParams = {
          pageTypeIns: 'PDP',
          roxLensCatentryId: _insurancePackages[i].lensPackage.catEntryId,
          roxFrameCatentryId: frameroxFrameCatEntryId,
        }
        const benefitsResponse = await WcsEyemed.makeBenefitPricingCall(postParams)
        if (benefitsResponse) {
          if (benefitsResponse.lensFinalPrice) {
            const insuranceLensPrice = benefitsResponse.lensFinalPrice.replace(
              benefitsResponse.currencySymbol,
              ''
            )
            _insurancePackages[i].lensPackage.insPrice = insuranceLensPrice
          }
          if (benefitsResponse.frameFinalPrice) {
            const insuranceFramePrice = benefitsResponse.frameFinalPrice.replace(
              benefitsResponse.currencySymbol,
              ''
            )
            _insurancePackages[i].frame.insPrice = insuranceFramePrice
          }
          updateBenefits(benefitsResponse)
        }
      }
      resolve(_insurancePackages)
    })
  }
  static emitEarlyAccessEligibleEvent = (): void => {
    window.dispatchEvent(
      new CustomEvent(this.getEarlyAccessModule().getEvents().EARLY_ACCESS_ELIGIBILITY_CHANGED)
    )
  }
}
